import "./audio-player-overrides.css";

import { ComponentProps, FC } from "react";
import { AudioPlayer as ReactAudioPlay } from "react-audio-play";

type Props = ComponentProps<typeof ReactAudioPlay>;

export const AudioPlayer: FC<Props> = (props) => (
  <ReactAudioPlay
    preload="metadata"
    width="400px"
    color="rgb(63, 63, 70)"
    sliderColor="rgb(63, 63, 70)"
    {...props}
  />
);
